import axios from "axios";
import { headers } from "./headers";
import { baseUrl } from "./URL";

export const rechecherroles = async() =>{
    return  await axios.get(baseUrl("rechercherroles"),headers);
}